import {
  faLinkedin,
  faFacebook,
  faTwitter,
} from '@fortawesome/free-brands-svg-icons';
import Icon from 'components/Icon/Icon';
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
} from 'react-share';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import SubscribeForm from 'components/Blog/SubscribeForm/SubscribeForm';

import classes from './SNSbox.module.css';

const SNSbox = (props) => {
  let mailUrl = null;
  if (props.blogPost) {
    mailUrl = `mailto:?subject=${props.blogPost.title.rendered}&body=${props.postUrl}`;
  }

  return (
    <div className={classes['sns-box-wrap']}>
      <div className={classes['sns-box']}>
        <h3 className={classes['sns-box__heading']}>Share This Post:</h3>
        <div className={classes.icons}>
          <LinkedinShareButton url={props.postUrl}>
            <FontAwesomeIcon icon={faLinkedin} />
          </LinkedinShareButton>
          <FacebookShareButton url={props.postUrl}>
            <FontAwesomeIcon icon={faFacebook} />
          </FacebookShareButton>
          <TwitterShareButton url={props.postUrl}>
            <FontAwesomeIcon icon={faTwitter} />
          </TwitterShareButton>
          <Icon icon={faEnvelope} href={mailUrl} />
        </div>
        <SubscribeForm />
      </div>
    </div>
  );
};

export default SNSbox;
